import MaterialIconsReact from 'material-icons-react';
import { useEffect, useState } from 'react';
import Card from '../../components/Card';
import InfoMessage from '../../components/InfoMessage';
import { fetchMaterialImage, fetchSwatchData } from '../../services/station';
import styles from './ScanCard.module.css';

function ScanCard(props) {
  const [imageMap, setImageMap] = useState('');

  const getImage = async (itemCode) => {
    const swatchData = await fetchSwatchData({
      item_code: itemCode
    });
    if (typeof swatchData.message !== 'string') {
      const imageData = await fetchMaterialImage({
        docid: swatchData.message.swatch_id
      })
      setImageMap({[itemCode] : 'data:image/png;base64,' + imageData.message.data})
    } 
  }

  useEffect(() => {
    getImage(props.boardScanData.book.material);
  }, [])
  let rawData;
  if (typeof props.boardScanData.book.raw_data === 'string') {
    rawData = JSON.parse(props.boardScanData.book.raw_data);
  } else {
    rawData = props.boardScanData.book.raw_data;
  }

  const panelData = rawData.parts;
  return (
    <Card>
      <div className={styles.cardHeader}>
        <div className={styles.contentWrapper}>
          <div>
            <div className='bold ft-20'>{props.boardScanData.book.cut_parts || props.finishedParts.length} / {props.boardScanData.book.parts_count}</div>
            <div className={styles.subText}>Panel Quantity</div>
          </div>
          <div>
            <div className='bold ft-20'>{props.boardScanData.book.boardcount}</div>
            <div className={styles.subText}>Book Height</div>
          </div>
        </div>
        <div className={styles.flexContainer}>
          <span>Trouble scanning?</span>
          <a className={styles.addManually} onClick={props.addManually}>Add manually</a>
          <InfoMessage message='Scan a board to start the process'></InfoMessage>
        </div>
      </div>
      <div className='line'></div>
      <div className={styles.cardContent}>
        <div className={styles.leftContent}>
          <div>Panels in this board</div>
          <ul className={styles.panelList}>
            {panelData.map((panel, index) => {
              let finished = props.finishedParts.indexOf(panel.part) > 0;
              return (
                <li className={finished ? styles.finished : ''} key={index}>
                  <MaterialIconsReact size={20} color={'#666666'} icon={'chevron_right'}></MaterialIconsReact>
                  <span className={styles.ml8}>{panel.part}</span>
                  {finished && <span className={styles.finishIcon}>
                    <MaterialIconsReact size={20} color={'#666666'} icon={'check_circle'} invert></MaterialIconsReact>
                  </span>}
                </li>
              )
            })}
          </ul>
        </div>
        <div className={styles.rightContent}>
          <img className={styles.materialImage} src={'data:image/png;base64,' + props.boardScanData.book.image}></img>
        </div>
      </div>
      <div className='line'></div>
      <div className={styles.cardFooter}>
        <div>
          {props.boardScanData.inventory ? props.boardScanData.inventory.detail.notes : props.boardScanData.book.material}
        </div>
        <div>
          {/* <img className={styles.boardImage} src={imageMap[props.boardScanData.book.material]}></img> */}
          <img className={styles.boardImage} src={imageMap[props.boardScanData.book.material]}></img>
          {/* <img className={styles.boardImage} src={imageMap[props.boardScanData.book.material]}></img> */}
        </div>
      </div>
    </Card>
  );
}

export default ScanCard;
